import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import ListingDataComp from './ListingDataComp'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
// import AmountPaid from './AmountPaid'
import ExtendDetails from './ExtendDetails'
import { getExtendList } from '../../redux/actions/ExtendFromAction'
import Loader from '../../global/Loader'
// import { priceGreaterOrNot } from '../../utils/helper'
import pdf_icon from '../../assets/img/pdf_icon.png'

function PaymentBreakUpDetails(props) {
    const { dispatch, className, paymentData, loader,isSubmittingForm, isDisplayDetails, setIsDisplayDetails, isExtendDetails, screen, breakDownTitle } = props
    const [extendedDetails, setExtendedDetails] = useState(EMPTY_ARRAY)
    const [isFetchingExtendDetails, setIsfetchingExtendDetails] = useState(false)
    const [isExtendDisplay, setIsExtendDisplay] = useState(false)
    useEffect(() => {
        setIsDisplayDetails(false)
        if (isExtendDetails) {
            let ticket = undefined
            if(screen && screen == 'extendResponse'){
                ticket = JSON.parse(localStorage.getItem('ExtendData'))?.ticket_number
            }else{
                ticket = JSON.parse(localStorage.getItem('paymentRecipt'))?.ticket_number
            }
            
            if (ticket) {
                setIsfetchingExtendDetails(true)
                dispatch(getExtendList(ticket)).then((res) => {
                    setIsfetchingExtendDetails(false)
                    if (res.data && res.data.length > 0) {
                        setExtendedDetails(res?.data)
                    } else {
                        setExtendedDetails(EMPTY_ARRAY)
                    }
                }).catch(() => {
                    setIsfetchingExtendDetails(false)
                    setExtendedDetails(EMPTY_ARRAY)
                })
            }
        }
    }, [EMPTY_ARRAY, isExtendDetails])

    // const handleCloseDetails = () => {
    //     setIsDisplayDetails(false)
    // }

    const handleFetchingExtendDetails = () => {
        setIsExtendDisplay(!isExtendDisplay)
    }

    return (
        // Uncomment for Displaying in Modal
        // isDisplayDetails && <div className='zIndexMid cover'>
        //     <div className='zIndexHigh opacity-100 bottom-0 datalist text-center pb-3'>
        //         <p className='text-primary mt-2 mb-4 fw-semibold'>Price Breakdown</p>
        // Uncomment for Displaying in Modal

        isDisplayDetails && <>
            <div className="card-header  d-flex justify-content-between">
                <p className="card-title text-primary fw-bold">{breakDownTitle ? breakDownTitle : 'Price Breakdown'}</p>
                {/* <i className="fa fa-file"></i> */}
                <img src={pdf_icon} width="22px" height="21px" />
            </div>
            <div className="card-body">
                <ListingDataComp loader={isSubmittingForm ? false :loader} paymentData={paymentData} />
                {(extendedDetails.length > 0) ? ((isExtendDetails && isFetchingExtendDetails) ? <Loader isMargin /> : <div className='mb-2 text-end'>
                    <span data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" className='text-primary' onClick={handleFetchingExtendDetails}>More Details {isExtendDisplay ? <i className='fa fa-circle-xmark' /> : <i className='fa fa-circle-arrow-right' />}</span>
                </div>) : null}
                {(isExtendDetails && Object.keys(extendedDetails).length > 0) && <ExtendDetails
                    className={className ? className : 'bg-white py-2'}
                    extendedDetails={extendedDetails}
                />}
            </div>
            {/* <div className='px-3'>
                <div className=''>
                    <ListingDataComp loader={isSubmittingForm? false :loader} paymentData={paymentData} />
                    {(extendedDetails.length > 0) ? ((isExtendDetails && isFetchingExtendDetails) ? <Loader isMargin /> : <div className='mb-2 text-end'>
                        <span className='fw-bold p-0 m-0 ticket-font text-primary' onClick={handleFetchingExtendDetails}>More Details {isExtendDisplay ? <i className='fa fa-circle-xmark me-3' /> : <i className='fa fa-circle-arrow-right me-3' />}</span>
                    </div>) : null}
                    {(isExtendDetails && Object.keys(extendedDetails).length > 0 && isExtendDisplay) && <ExtendDetails
                        className={className ? className : 'bg-white py-2'}
                        extendedDetails={extendedDetails}
                    />}
                </div>
            </div> */}
        </>
    )
}

PaymentBreakUpDetails.propTypes = {
    dispatch: PropTypes.func,
    className: PropTypes.string,
    faciltyData: PropTypes.object,
    sectionKey: PropTypes.string,
    paymentData: PropTypes.object,
    loader: PropTypes.bool,

    isDisplayDetails: PropTypes.bool,
    isExtendDetails: PropTypes.bool,
    setIsDisplayDetails: PropTypes.func,
    isSubmittingForm: PropTypes.bool,
    screen: PropTypes.string,
    breakDownTitle: PropTypes.string,
}

PaymentBreakUpDetails.defaulProps = {
    dispatch: noop,
    className: '',
    faciltyData: EMPTY_OBJECT,
    sectionKey: '',
    paymentData: EMPTY_OBJECT,
    loader: false,
    isSubmittingForm: false,

    isDisplayDetails: false,
    isExtendDetails: false,
    setIsDisplayDetails: noop,
    screen: undefined,
    breakDownTitle: undefined,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(PaymentBreakUpDetails)